import { render, staticRenderFns } from "./CreateCustomItemPopup.vue?vue&type=template&id=c07d028e"
import script from "./CreateCustomItemPopup.vue?vue&type=script&lang=js"
export * from "./CreateCustomItemPopup.vue?vue&type=script&lang=js"
import style0 from "./CreateCustomItemPopup.vue?vue&type=style&index=0&id=c07d028e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports